export default "__VITE_ASSET__VopWemoU__"